import { render } from "./Token.vue?vue&type=template&id=a275c068&scoped=true&ts=true"
import script from "./Token.vue?vue&type=script&lang=ts"
export * from "./Token.vue?vue&type=script&lang=ts"

import "./Token.vue?vue&type=style&index=0&id=a275c068&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a275c068"]])

export default __exports__